import React from "react";
import Link from 'gatsby-link'
import SvgBtnCapsule from '../../images/bouton-capsule.svg'
import preview1 from './../../images/capsule-preview-corbeau-1.png'
import preview2 from './../../images/capsule-preview-corbeau-2.png'
import preview3 from './../../images/capsule-preview-corbeau-3.png'
import preview4 from './../../images/capsule-preview-corbeau-4.png'

export default () => (
  <a href="https://www.lafabriqueculturelle.tv/capsules/10839/lva-v-memoire-du-corbeau" className="etiquette capsule">
    <div className="capsule-container">
        <img src={preview4} alt=""/>
        <img src={preview3} alt=""/>
        <img src={preview2} alt=""/>
        <img src={preview1} alt=""/>
        <SvgBtnCapsule/>
    </div>
    <span>LVA V. Mémoire du corbeau</span>
  </a>
);



// WEBPACK FOOTER //
// ./src/components/btn-capsule-corbeau.js